export const IS_TEST = process.env.APP_NODE_ENV === `test`;
export const IS_PRODUCTION = process.env.REACT_APP_ENVIRONMENT === `production`;
export const IS_DEVELOPMENT = process.env.REACT_APP_ENVIRONMENT === `development`;
export const CLARITY_PROJECT_ID = process.env.REACT_APP_CLARITY_PROJECT_ID ?? ``;
export const API_URL =
  process.env.REACT_APP_API_URL ?? `https://prisma-workr-services-wnsh2cwpuq-uc.a.run.app`;
export const AI_API_URL =
  process.env.REACT_APP_AI_API_URL || `https://astri-workr-ai-wnsh2cwpuq-uc.a.run.app`;

export const API_WEBCAST = process.env.REACT_APP_WEBCAST_URL || `http://localhost:3001`;

// alterar depois
export const OTHER_SERVICES_PERMISSION_ID =
  process.env.OTHER_SERVICES_PERMISSION_ID || 'other-services-id';

export const CALENDAR_PERMISSION_ID =
  process.env.CALENDAR_PERMISSION_ID || 'calendar-id';

export const REPORTS_PERMISSION_ID =
  process.env.REPORTS_PERMISSION_ID || 'reports-id';

export const FIREBASE_API_KEY =
  process.env.REACT_APP_FIREBASE_API_KEY || `AIzaSyAxULDbz-E7YSTtZlpIZM_FFvPr7lK7BdU`;
export const FIREBASE_AUTH_DOMAIN =
  process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || `hml-worker-v2.firebaseapp.com`;
export const FIREBASE_AUTH_PROJECT_ID =
  process.env.REACT_APP_FIREBASE_AUTH_PROJECT_ID || `hml-worker-v2`;
export const FIREBASE_STORAGE_BUCKET =
  process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || `hml-worker-v2.appspot.com`;
export const FIREBASE_MESSAGING_SENDER_ID =
  process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || `214774278061`;
export const FIREBASE_APP_ID =
  process.env.REACT_APP_FIREBASE_APP_ID || `1:214774278061:web:84e40a6b74de8f83a52324`;

export const IRM_PERMISSION_ID =
  process.env.IRM_PERMISSION_ID || `5e05fafa-5958-45a2-903e-973d4c272a14`;
export const CRM_PERMISSION_ID = process.env.CRM_PERMISSION_ID || `CRM-ID`;
export const ADMIN_PERMISSION_ID =
  process.env.ADMIN_PERMISSION_ID || `8edc72b5-f8a1-4991-acba-61407c519357`;
export const CMS_PERMISSION_ID = process.env.CMS_PERMISSION_ID || `CMS-ID`;
export const AUTOMATION_PERMISSION_ID = process.env.AUTOMATION_PERMISSION_ID || `AUTOMATION-ID`;
export const EMAIL_PERMISSION_ID =
  process.env.EMAIL_PERMISSION_ID || `515391f5-c884-478d-a866-93d9b4ffc74f`;
export const WEBCAST_PERMISSION_ID =
  process.env.WEBCAST_PERMISSION_ID || `2b9350f4-5038-4bcc-83a1-663b40b24051`;
export const USER_PERMISSION_ID =
  process.env.USER_PERMISSION_ID || `fd29614e-2047-4826-a65d-09fbcfb90fa8`;
export const COMPANY_PERMISSION_ID =
  process.env.COMPANY_PERMISSION_ID || `978953d4-5f78-4917-81cd-6a0e7ebfc988`;

export const WEBCAST_URL = process.env.REACT_APP_WEBCAST_URL || `http://localhost:3001`;
export const WEBCAST_TOKEN =
  process.env.REACT_APP_WEBCAST_TOKEN || `lbkFJEyS68pnc9g9BumCMDK9hskZ8E9dsGW3skhSv68Ztg6T3B`;

export const BUCKET_ADMIN = process.env.REACT_APP_BUCKET_ADMIN || `hml-prisma-admin`;

// Configuração do Zendesk
export const ZENDESK_SUBDOMAIN = process.env.REACT_APP_ZENDESK_SUBDOMAIN || 'riprisma';
export const ZENDESK_EMAIL = process.env.REACT_APP_ZENDESK_EMAIL || 'l.barra@riprisma.com';
export const ZENDESK_API_TOKEN =
  process.env.REACT_APP_ZENDESK_API_TOKEN || 'FvVMW8HFQLge87vM13OTbtTZ3U5plILNgOeYXYtU';


// IDs dos formulários do Zendesk
export const ZENDESK_FORM_IDS = {
  SUPORTE: process.env.REACT_APP_ZENDESK_FORM_SUPORTE || '5454696923419',
  'ATENDIMENTO CVM/B3': process.env.REACT_APP_ZENDESK_FORM_ATENDIMENTO || '36782604241947',
  'CONSULTORIA E PROJETOS': process.env.REACT_APP_ZENDESK_FORM_CONSULTORIA || '36802199340443',
  ADMINISTRATIVO: process.env.REACT_APP_ZENDESK_FORM_ADMINISTRATIVO || '36802368281627',
};
